<script setup>
import Button from '@/common/Button.vue'

defineProps({
    viewId: String,
    offCanvasId: String
})
</script>

<template>
    <!-- Added @click to guarantee proper Bootstrap offcanvas intercept hooks -->
    <Button data-bs-toggle="offcanvas" :data-bs-target="'#' + offCanvasId" :aria-controls="offCanvasId"
            class="btn-sm btn-link text-decoration-none">
        <small>filters</small>
    </Button>
</template>